import React, {ComponentProps, Fragment, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/sampleCalcProportion";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import Divider from "../../components/Divider";
import {Button, Input, message, Popconfirm, Space} from "antd";
import UploadModal from "../../components/UploadModal";
import {useRequest} from "ahooks";
import {Link, useHistory} from "react-router-dom";
import withAuth from "../../utils/withAuth";


const ImportProductButton = withAuth('importProduct', Button);
const ImportProportionButton = withAuth('importProportion', Button);
const StatusFragment = withAuth('status', Fragment);
const DeletePopconfirm = withAuth('delete', Popconfirm);

function CalcProportion(props: ComponentProps<any>) {
    const history = useHistory();
    const [productImportModalVisible, setProductImportModalVisible] = useState(false);
    const [proportionImportModalVisible, setProportionImportModalVisible] = useState(false);

    const {loading: loadingProductImport, run: runProductImport} = useRequest(api.importReagentExcel, {
        manual: true,
        onSuccess(res) {
            message.success('导入成功');
            setProductImportModalVisible(false)
            refresh();
        }
    });
    const {loading: loadingProportionImport, run: runProportionImport} = useRequest(api.importProportionExcel, {
        manual: true,
        onSuccess(res) {
            setProportionImportModalVisible(false);
            refresh();
        }
    });

    const {loading: loadingEdit, run: runEdit} = useRequest(api.updateProduct, {
        manual: true,
        onSuccess(res) {
            refresh();
        }
    });

    const {run: switchStatus} = useRequest(api.switchStatus, {
        manual: true,
        onSuccess(res) {
            message.success('成功');
            refresh();
        }
    })

    const {loading: loadingDelete, run: runDelete} = useRequest(api.deleteReagent, {
        manual: true,
        onSuccess() {
            refresh();
        }
    });

    const {tableProps, form, search, refresh} = useAntTable(api.getReagents, {});

    const columns: StandardColumnsType = [
        {
            dataIndex: 'reagentCode',
            title: '试剂商品编号'
        },
        {
            dataIndex: 'reagentName',
            title: '试剂商品名称'
        },
        {
            dataIndex: 'specification',
            title: '规格'
        },
        {
            dataIndex: 'proportion',
            title: '比例'
        },
        {
            dataIndex: 'status',
            title: '状态',
            render(v) {
                return v ? '启用' : '停用'
            }
        },
        {
            dataIndex: 'operation',
            title: '操作',
            render(v: any, record: any) {
                return <Divider>
                    <Link to={`/sample/calcProportion/detail/${record.id}`}>详情</Link>
                    <StatusFragment><a
                        onClick={() => switchStatus(record.id)}>{record.status ? '停用' : '启用'}</a></StatusFragment>
                    <DeletePopconfirm title={'是否确认删除'} onConfirm={() => handleDelete(record.id)}>
                        <a style={{color: 'var(--danger-color)'}}>删除</a>
                    </DeletePopconfirm>
                </Divider>
            }
        }
    ];

    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'reagentProductNumber',
            title: '商品编号/名称',
            search: true
        },
        {
            dataIndex: 'status',
            title: '状态',
            search: {
                valueType: 'check'
            }
        }
    ];

    const handleDelete = (id: number) => {
        runDelete(id);
    }

    const handleImportProductExcel = () => {
        setProductImportModalVisible(true);
    }

    const handleImportProportionExcel = () => {
        setProportionImportModalVisible(true);
    }

    const toolbar = (
        <Space>
            <ImportProductButton type={'primary'} onClick={handleImportProductExcel}>导入试剂</ImportProductButton>
            <ImportProportionButton type={'primary'}
                                    onClick={handleImportProportionExcel}>导入比例</ImportProportionButton>
        </Space>
    );

    return <PageHeaderLayout>
        <StandardTable {...tableProps} submit={search.submit} columns={columns} form={form}
                       extSearchColumns={searchColumns} toolbar={toolbar}/>
        <UploadModal key={'productImport'}
                     onUpload={runProductImport}
                     open={productImportModalVisible}
                     title={'导入试剂'}
                     template={'/template/样品额度计算比例表-试剂导入模板.xlsx'}
                     confirmLoading={loadingProductImport}
                     onCancel={() => setProductImportModalVisible(false)}/>
        <UploadModal key={'proportionImport'}
                     onUpload={runProportionImport}
                     open={proportionImportModalVisible}
                     title={'导入比例'}
                     template={'/template/样品额度计算比例-比例导入模板.xlsx'}
                     confirmLoading={loadingProportionImport}
                     onCancel={() => setProportionImportModalVisible(false)}/>
    </PageHeaderLayout>
}

export default CalcProportion;
